module.exports = __webpack_public_path__ + "ncaret_right_icon.svg";